import { FilmwebCMSImage } from "@/components/image/CMSImage";
import MovieTitle from "@/components/poster/MovieTitle";
import PosterContainerLink from "@/components/poster/PosterContainerLink";
import PosterWrapper from "@/components/poster/PosterWrapper";
import ShowInfo from "@/components/poster/ShowInfo";
import TextContainer from "@/components/poster/TextContainer";
import MissingPoster from "@/components/program/MissingPoster";
import ShowTime from "@/components/program/ShowTime";
import { type ShowWithMovie } from "@/lib/client/getShowsAndMovies";
import { parse } from "date-fns";
import {nb as locale} from "date-fns/locale/nb";
import { useMemo } from "react";

//#region [Props]
type ProgramPosterProps = {
    show: ShowWithMovie;
    className?: string;
    noPoster?: boolean;
};
//#endregion

//#region [Component]
export default function ProgramShow({ show, className, noPoster = false }: ProgramPosterProps) {
    const imageId = useMemo(() => {
        if (noPoster === false && show.movie.sanityImagePosterUrl) {
            const match = imageIdExtract.exec(show.movie.sanityImagePosterUrl);
            if (match) {
                return `image-${match[1]}-${match[2]}`;
            }
        }
        return undefined;
    }, [show.movie.sanityImagePosterUrl, noPoster]);

    const parsedTime = useMemo(() => {
        if (show.showStart) {
            return parse(show.showStart, "yyyy-MM-dd'T'HH:mm:ss", new Date(), { locale });
        }

        return undefined;
    }, [show.showStart]);

    if (!parsedTime) {
        return null;
    }

    return <PosterWrapper className={className}>
        {noPoster === false && <PosterContainerLink href={`/film/${show.movieMainVersionId}`}>
            {imageId && <FilmwebCMSImage assetRef={imageId} altText={`Plakat for '${show.movieTitle}'`} width={310} />}
            {!imageId && <MissingPoster text="!"/>}
        </PosterContainerLink>}
        <TextContainer>
            {noPoster === false && <MovieTitle show={show} href={`/film/${show.movieMainVersionId}`} />}
            <ShowInfo info={`${show.screenName}, ${show.location}`} />
            <ShowTime ticketSaleUrl={show.ticketSaleUrl} showStart={parsedTime} />
            <ShowInfo info={show.showType} />
            <ShowInfo info={show.showInfo} />
        </TextContainer>
    </PosterWrapper>;
}


//#endregion
//"https://cdn.sanity.io/images/j0wdmpyb/production/cafe62b0195e8ebeaf12c7537c245e77e2456e8e-770x1100.jpg?auto=format
const imageIdExtract = /^https:\/\/cdn.sanity.io\/images\/j0wdmpyb\/production\/(.*?)\.(.*?)(?:\?(.*?))?$/i;
